<div class="basic-info-detail" *transloco="let t">
  <app-child-detail-alert-info
    *ngIf="
      child.isHealthDisadvantaged ||
      (child.levelOfTalent && child.levelOfTalent !== levelOfTalentEnum.BezIdentifikovanhoNadnNeboMimodnhoNadn)
    "
    [child]="child"
  ></app-child-detail-alert-info>

  <div class="buttons-wrapper">
    <ng-container *ngIf="(transitionReportEnabled$ | async) && child?.age >= 5">
      <!-- Transition report link -->
      <a [href]="tAppUrl.url" [target]="tAppUrl.target" class="btn btn-primary btn-black">{{ t('transitionReport/change') }}</a>
      <!-- Transition report download -->
      <button class="btn btn-primary btn-black" (click)="downloadTransitionReport()">{{ t('transitionReport/download') }}</button>
    </ng-container>

    <a [routerLink]="links.editChildSpzRecommendations(child.childId)" class="btn btn-primary">{{ t('child/viewSpzRecommendations') }}</a>
  </div>

  <form class="flex-form">
    <div class="row no-gutters">
      <div class="form-group">
        <label for="attendanceStart">{{ t('child/attendanceStart') }}</label>
        <div id="attendanceStart" class="value">{{ child.attendanceStart | date : 'd. M. y' }}</div>
      </div>
      <div class="form-group">
        <label for="attendanceStartCode">{{ t('child/attendanceStartCode') }}</label>
        <div id="attendanceStartCode" class="value">
          {{ child.attendanceStartCode | transformEnumToReadableString : attendanceStartCode }}
        </div>
      </div>
      <div class="form-group">
        <label for="attendanceFulfillmentMethod">{{ t('child/attendanceFulfillmentMethod') }}</label>
        <div id="attendanceFulfillmentMethod" class="value">
          {{ child.attendanceFulfillmentMethod | transformEnumToReadableString : attendanceFulfillmentMethod }}
        </div>
      </div>
    </div>

    <div class="row no-gutters">
      <div class="form-group">
        <label for="attendanceEnd"> {{ t('child/attendanceEnd') }}</label>
        <div id="attendanceEnd" class="value">{{ child.attendanceEnd | date : 'd. M. y' }}</div>
      </div>
      <div class="form-group">
        <label for="attendanceEndCode">{{ t('child/attendanceEndCode') }}</label>
        <div id="attendanceEndCode" class="value">{{ child.attendanceEndCode | transformEnumToReadableString : attendanceEndCode }}</div>
      </div>
      <div class="form-group">
        <label for="educationCourseChoice">{{ t('child/educationCourseChoice') }}</label>
        <div id="educationCourseChoice" class="value">
          {{ child.educationCourseChoice | transformEnumToReadableString : educationCourseChoice }}
        </div>
      </div>
    </div>

    <div class="row no-gutters">
      <div class="form-group">
        <label for="healthInsurance">{{ t('child/healthInsurance') }}</label>
        <div id="healthInsurance" class="value">{{ child.insuranceCompany | transformEnumToReadableString : insuranceCompany }}</div>
      </div>
      <div class="form-group">
        <label for="measureLevel">{{ t('child/measureLevel') }}</label>
        <div id="measureLevel" class="value">{{ measureLevel[child.measureLevel] }}</div>
      </div>
    </div>

    <div class="row no-gutters">
      <div class="form-group">
        <label for="ignoranceOfLanguage">{{ t('child/knowledgeOfLanguage') }}</label>
        <i *ngIf="!child.ignoranceOfLanguage" [class]="iconsService.checkCircle + ' check'"></i>
        <i *ngIf="child.ignoranceOfLanguage" [class]="iconsService.xCircle + ' warning'"></i>
      </div>
      <div class="form-group">
        <label for="socialCategoryDisadvantage">{{ t('child/socialCategoryDisadvantage') }}</label>
        <div id="socialCategoryDisadvantage" class="value">{{ socialCategoryDisadvantage[child.socialCategoryDisadvantage] }}</div>
      </div>
      <div class="form-group" *ngIf="child.socialCategoryDisadvantage === socialCategoryDisadvantageEnum.EvaluationOfSevenKeyAreas">
        <label for="socialDisadvantageCode">{{ t('child/socialDisadvantageCode') }}</label>
        <div id="socialDisadvantageCode" class="value">{{ child.socialDisadvantageCode }}</div>
      </div>
    </div>

    <div class="row no-gutters">
      <div class="form-group">
        <label for="hasHeavyDisability">{{ t('child/hasHeavyDisability') }}</label>
        <i *ngIf="child.hasHeavyDisability" [class]="iconsService.checkCircle + ' check'"></i>
        <i *ngIf="!child.hasHeavyDisability" [class]="iconsService.xCircle + ' warning'"></i>
      </div>
      <div class="form-group">
        <label for="disabilityType">{{ t('child/disabilityType') }}</label>
        <div id="disabilityType" class="value">{{ child.disabilityType }}</div>
      </div>
      <div class="form-group">
        <label for="disadvantageIdentifier">{{ t('child/disadvantageIdentifier') }}</label>
        <div id="disadvantageIdentifier" class="value">{{ child.idZnev }}</div>
      </div>
    </div>
  </form>
</div>
